import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TGetLimitsOperationsDataResponse,
  TGetLimitsUsersDataResponse,
  TSetLimitsOperationsDataRequest,
  TSetLimitsOperationsDataResponse,
  TSetLimitsUsersDataRequest,
  TSetLimitsUsersDataResponse,
  TGetLimitsCustomerAmountDataResponse,
  TGetLimitsCustomerPaymentDataResponse,
  TSetLimitsCustomerAmountDataRequest,
  TSetLimitsCustomerAmountDataResponse,
  TSetLimitsCustomerPaymentDataResponse,
  TSetLimitsCustomerPaymentDataRequest,
} from '../types/limits.types';

export const getLimitsUsersDataService = async (counterpartyGUID: string): Promise<TGetLimitsUsersDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_USERS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.get<TGetLimitsUsersDataResponse>(url);

  return res.data;
};

export const setLimitsUsersDataService = async (
  counterpartyGUID: string,
  reqData: TSetLimitsUsersDataRequest,
): Promise<TSetLimitsUsersDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_USERS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TGetLimitsUsersDataResponse>(url, reqData);

  return res.data;
}

export const getLimitsOperationsDataService = async (
  counterpartyGUID: string,
): Promise<TGetLimitsOperationsDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_OPERATIONS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.get<TGetLimitsOperationsDataResponse>(url);

  return res.data;
};

export const setLimitsOperationsDataService = async (
  counterpartyGUID: string,
  reqData: TSetLimitsOperationsDataRequest,
): Promise<TSetLimitsOperationsDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_OPERATIONS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TSetLimitsOperationsDataResponse>(url, reqData);

  return res.data;
}

export const getLimitsCustomerAmountService = async (
  counterpartyGUID: string,
  params: {
    customer_guid: string,
  },
): Promise<TGetLimitsCustomerAmountDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_CUSTOMER_AMOUNT
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = { params };
  const res = await apiClient.get<TGetLimitsCustomerAmountDataResponse>(url, config);

  return res.data;
};

export const setLimitsCustomerAmountService = async (
  counterpartyGUID: string,
  reqData: TSetLimitsCustomerAmountDataRequest,
): Promise<TSetLimitsCustomerAmountDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_CUSTOMER_AMOUNT
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TSetLimitsCustomerAmountDataResponse>(url, reqData);

  return res.data;
}

export const getLimitsCustomerPaymentService = async (
  counterpartyGUID: string,
  params: {
    customer_guid: string,
  },
): Promise<TGetLimitsCustomerPaymentDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_CUSTOMER_PAYMENT
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = { params };
  const res = await apiClient.get<TGetLimitsCustomerPaymentDataResponse>(url, config);

  return res.data;
};

export const setLimitsCustomerPaymentService = async (
  counterpartyGUID: string,
  reqData: TSetLimitsCustomerPaymentDataRequest,
): Promise<TSetLimitsCustomerPaymentDataResponse> => {
  const url = API_ENDPOINTS.LIMITS.COUNTERPARTY_LIMITS_CUSTOMER_PAYMENT
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TSetLimitsCustomerPaymentDataResponse>(url, reqData);

  return res.data;
}
